// Line-of-business options for the Add Policy picker, and the order they are shown in.
//
// AMS lines of business carry a `class` (Commercial, Personal, Life-Health, Medicare, or
// blank) that the picker used to drop. That let a Life-Health line called "Umbrella Coverage"
// sit next to "Commercial Umbrella" looking identical — and NowCerts never maps a Life-Health
// policy to a certificate coverage row, so the agent got a blank, read-only policy number
// cell. Keeping the class lets the picker label each row and put Commercial lines first.
//
// Grouping is per page: AMS caps every response at 20 rows and filters on the search term
// before capping, so a search like "umbrella" returns its handful of variants on one page.

export type LobOption = { name: string; id: string; cls: string };

const CLASS_ORDER = ['Commercial', 'Personal'];

/** Lower ranks first. Commercial, then Personal, then everything else (Life-Health, Medicare, blank). */
export function lobClassRank(cls: string): number {
  const i = CLASS_ORDER.indexOf(cls);
  return i === -1 ? CLASS_ORDER.length : i;
}

/** Commercial and Personal lines are the ones that map to certificate coverage rows. */
export function isCertificateLobClass(cls: string): boolean {
  return lobClassRank(cls) < CLASS_ORDER.length;
}

/** Stable: class rank first, then name (case-insensitive) within a class. */
export function groupLobOptions(items: LobOption[]): LobOption[] {
  return [...items].sort(
    (a, b) =>
      lobClassRank(a.cls) - lobClassRank(b.cls) ||
      a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
  );
}
